const PREFIX = 'rbx-report-filters:';

const keyFor = (userId, tenancyId) => `${PREFIX}${userId ?? ''}:${tenancyId ?? ''}`;

export function readReportFilterSession(userId, tenancyId) {
    try {
        const raw = sessionStorage.getItem(keyFor(userId, tenancyId));
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

export function writeReportFilterSession(userId, tenancyId, json) {
    try {
        sessionStorage.setItem(keyFor(userId, tenancyId), json);
    } catch {
        return;
    }
}

export function clearReportFilterSessions() {
    try {
        const keys = [];
        for (let i = 0; i < sessionStorage.length; i++) {
            const key = sessionStorage.key(i);
            if (key && key.startsWith(PREFIX)) keys.push(key);
        }
        keys.forEach((key) => sessionStorage.removeItem(key));
    } catch {
        return;
    }
}
